var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D9D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 5.25433L13.4594 9.74333L13.5156 9.91607H13.6972H18.4172L14.5986 12.6904L14.4517 12.7972L14.5078 12.9699L15.9664 17.4589L12.1478 14.6846L12.0009 14.5778L11.8539 14.6846L8.03535 17.4589L9.49392 12.9699L9.55004 12.7972L9.4031 12.6904L5.58453 9.91607H10.3045H10.4862L10.5423 9.74333L12.0009 5.25433Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/starGray.8cfabdad.svg";
export { ForwardRef as ReactComponent };